/**
 * Business dates are America/Chicago calendar dates. `new Date().toISOString()`
 * is UTC, so after ~7 PM Central it already reads tomorrow. Use these for every
 * default document / transaction date in the UI.
 */
export const BREWERY_TIME_ZONE = 'America/Chicago';

const fmt = new Intl.DateTimeFormat('en-CA', {
  timeZone: BREWERY_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

/** America/Chicago calendar date (YYYY-MM-DD) of an instant. */
export function centralDateOf(instant: Date | string | number): string {
  const d = instant instanceof Date ? instant : new Date(instant);
  if (Number.isNaN(d.getTime())) return '';
  const parts: Record<string, string> = {};
  for (const p of fmt.formatToParts(d)) parts[p.type] = p.value;
  return `${parts.year}-${parts.month}-${parts.day}`;
}

/** Today's America/Chicago date, YYYY-MM-DD. */
export function centralToday(now: Date = new Date()): string {
  return centralDateOf(now);
}

/** Current America/Chicago month, YYYY-MM. */
export function centralMonth(now: Date = new Date()): string {
  return centralToday(now).slice(0, 7);
}

/** America/Chicago date `n` days before today (calendar arithmetic, DST-safe). */
export function centralDaysAgo(n: number, now: Date = new Date()): string {
  const [y, m, d] = centralToday(now).split('-').map(Number);
  const base = new Date(Date.UTC(y, m - 1, d, 12));
  base.setUTCDate(base.getUTCDate() - n);
  return base.toISOString().slice(0, 10);
}
